import { Divider, MenuItem, Stack, Typography } from '@mui/material'
import React, { FC } from 'react'
import { getPxAsRem } from 'shared/utils'

interface MenuListItemButtonProps {
    title: string
    subtitle: string
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
    borderBottom?: boolean
}

const MenuListItemButton: FC<MenuListItemButtonProps> = ({
    title,
    subtitle,
    onClick,
    borderBottom = false,
}) => {
    return (
        <>
            <MenuItem
                onClick={onClick}
                component="button"
                sx={{
                    width: '100%',
                    textAlign: 'left',
                    padding: getPxAsRem(16),
                }}
            >
                <Stack>
                    <Typography variant="h6">{title}</Typography>
                    <Typography variant="body2">{subtitle}</Typography>
                </Stack>
            </MenuItem>
            {borderBottom && <Divider sx={{ margin: '0px !important' }} />}
        </>
    )
}

export default MenuListItemButton
